var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.499 0.5H19.998C19.722 0.5 19.497 0.725 19.497 1.001C19.497 1.55 19.047 2 18.498 2C17.949 2 17.499 1.55 17.499 1.001C17.499 0.725 17.274 0.5 16.998 0.5H0.501C0.225 0.5 0 0.725 0 1.001V15.002C0 15.278 0.225 15.503 0.501 15.503H17.001C17.277 15.503 17.502 15.278 17.502 15.002C17.502 14.453 17.952 14.003 18.501 14.003C19.05 14.003 19.5 14.453 19.5 15.002C19.5 15.278 19.725 15.503 20.001 15.503H23.499C23.775 15.503 24 15.278 24 15.002V1.001C24 0.725 23.775 0.5 23.499 0.5ZM23.001 14.501H20.43C20.205 13.64 19.431 13.001 18.501 13.001C17.571 13.001 16.797 13.64 16.572 14.501H0.999V1.499H16.569C16.788 2.339 17.532 2.963 18.438 2.993C18.192 3.023 18 3.224 18 3.479V4.109C18 4.385 18.225 4.61 18.501 4.61C18.777 4.61 19.002 4.385 19.002 4.109V3.479C19.002 3.224 18.807 3.017 18.564 2.99C19.47 2.966 20.214 2.336 20.433 1.496H23.001V14.501Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.501 5.49414C18.225 5.49414 18 5.71914 18 5.99514V6.62514C18 6.90114 18.225 7.12614 18.501 7.12614C18.777 7.12614 19.002 6.90114 19.002 6.62514V5.99514C19.002 5.71914 18.777 5.49414 18.501 5.49414Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.501 8.12891C18.225 8.12891 18 8.35391 18 8.62991V9.25991C18 9.53591 18.225 9.76091 18.501 9.76091C18.777 9.76091 19.002 9.53591 19.002 9.25991V8.62991C19.002 8.35391 18.777 8.12891 18.501 8.12891Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.501 10.7656C18.225 10.7656 18 10.9906 18 11.2666V11.8966C18 12.1726 18.225 12.3976 18.501 12.3976C18.777 12.3976 19.002 12.1726 19.002 11.8966V11.2666C19.002 10.9876 18.777 10.7656 18.501 10.7656Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99899 4.75005H8.49899C8.77499 4.75005 8.99999 4.52505 8.99999 4.24905C8.99999 3.97305 8.77499 3.74805 8.49899 3.74805H3.99899C3.72299 3.74805 3.49799 3.97305 3.49799 4.24905C3.49799 4.52505 3.72299 4.75005 3.99899 4.75005Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.25195H3.99899C3.72299 6.25195 3.49799 6.47695 3.49799 6.75295C3.49799 7.02895 3.72299 7.25395 3.99899 7.25395H12C12.276 7.25395 12.501 7.02895 12.501 6.75295C12.501 6.47695 12.276 6.25195 12 6.25195Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.75H3.99899C3.72299 8.75 3.49799 8.975 3.49799 9.251C3.49799 9.527 3.72299 9.752 3.99899 9.752H12C12.276 9.752 12.501 9.527 12.501 9.251C12.501 8.975 12.276 8.75 12 8.75Z",
    fill: "#757B81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 11.248H3.99899C3.72299 11.248 3.49799 11.473 3.49799 11.749C3.49799 12.025 3.72299 12.25 3.99899 12.25H12C12.276 12.25 12.501 12.025 12.501 11.749C12.501 11.473 12.276 11.248 12 11.248Z",
    fill: "#757B81"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_5977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTask);
export default __webpack_public_path__ + "static/media/task.cac119ad5d495ff8d1fa8fc2b0293616.svg";
export { ForwardRef as ReactComponent };